import React from 'react';
import { useLanguageLocale } from '../../../../hooks/language-locale-hooks';
import { LocationsDropdownToolbar } from '../../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { ContentContainer } from '../../../../components/ContentContainer';
import { useSelectedLocationData, isRecordFound } from '../../../../hooks/data-hooks';
import { RecordDataIndicators } from '../../../../components/RecordDataIndicators';
import { TimelineEvents } from '../../../../components/TimelineEvents';
import { TimelineDataProvider } from '../../../../data/DataProviders/TimelineDataProvider';
import { useAppRoute } from '../../../../hooks/app-route-hooks';
import { PopupProvider } from '../../../../data/DataProviders/TimelinePopupProvider';

export const TimelineLocationEvents: React.FC = () => {
    const [disableDownload,setdisableDownload] = React.useState<boolean>(false);
    const { t } = useLanguageLocale();
    const selectedLocationData = useSelectedLocationData();
    const currentAppRoute = useAppRoute('TimelineLocation');

      
    const isDisableDownload = (value: boolean): void => {
        setdisableDownload(value);
    }
   
    return (
        <>
            <PopupProvider>
                <LocationsDropdownToolbar title={t('DASHBOARD.TIMELINE_TITLE')} disableDownload={disableDownload} shouldIndicateAlarms />

                <ContentContainer testId="location-timeline-page">
                    <RecordDataIndicators
                        recordData={selectedLocationData}
                        errorMessage={t('DASHBOARD.ERROR_LOADING_LOCATION')}
                        notFoundIcon="Business"
                        notFoundMessage={t('DASHBOARD.LOCATION_NOT_FOUND')}
                    />

                    {isRecordFound(selectedLocationData) && (
                        <TimelineDataProvider organizationIdOrLocationIdOrSiteId={currentAppRoute.locationId}>
                            <TimelineEvents
                                showPath
                                appRoute={{
                                    type: 'TimelineLocationEventDetails',
                                    locationId: currentAppRoute.locationId,
                                    alarmId: '--',
                                    deviceId: '--',
                                }}
                                disableDownload ={isDisableDownload}
                            />
                        </TimelineDataProvider>
                    )}
                </ContentContainer>
            </PopupProvider>
        </>
    );
};
